/* esm.sh - applesauce-core@5.2.0/helpers/time */
export * from "/*applesauce-core@5.2.0/esnext/helpers/time.mjs";
